function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import { forEach, isArray, reduce, isEmpty } from 'lodash';
import { TOKKEN, dataMapping } from './constants';
export const fetchData = async (url, params, _ref) => {
  let {
    apiKey = '',
    sessionId = '',
    isTokkenValue = false,
    userTokken = null,
    keepalive = true,
    isGetRequest = false
  } = _ref;
  const headers = new Headers();
  headers.append('X-Request-Id', sessionId);
  headers.append('Apikey', apiKey);
  isTokkenValue && headers.append('Authorization', userTokken || TOKKEN);
  isGetRequest ? headers.append('Content-Type', 'none') : headers.append('Content-Type', 'application/json');
  headers.append('Accept', 'application/json');
  headers.append('Access-Control-Max-Age', '6000');
  headers.append('Access-Control-Allow-Origin', '*');
  headers.append('Host', 'dacqa.detsandbox.com');
  headers.append('User-Agent', 'Apidog/1.0.0 (https://apidog.com)');
  const requestOptions = _objectSpread(_objectSpread({}, params), {}, {
    headers,
    keepalive,
    withCredentials: true
  });
  try {
    const response = await fetch(url, requestOptions);
    try {
      const data = await response.json();
      if (isArray(data)) return data;
      return _objectSpread(_objectSpread({}, data), {}, {
        status: response.status
      });
    } catch {
      return {
        status: response.status
      };
    }
  } catch {
    return {};
  }
};
export const SaveLongTourismEntryPermit = async function (_ref2, context, isDraft) {
  let {
    apiUrl = '',
    apiKey = '',
    sessionId = '',
    userTokken = null,
    history,
    redirectUrl,
    username,
    serviceId = 'a2959b4f-bd7c-4243-8c7a-eab53903f6b4'
  } = _ref2;
  let applicationNumber = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
  const appid = applicationNumber.length ? {
    applicationNumber
  } : {};
  const staticData = {
    emailConsent: true,
    username,
    applicationInfo: _objectSpread({
      isDraft
    }, appid)
  };
  const data = reduce(dataMapping, (acc, fields, fieldName) => {
    if (isArray(fields) && fieldName) {
      let currentFieldGroup = acc[fieldName];
      forEach(fields, name => {
        let value = context[name] && context[name].value || '';
        if (context[name] && context[name].code && !value.startsWith('0')) value = context[name].code + value;
        const fieldData = context[name] && context[name].value && {
          [name]: value
        } || {};
        currentFieldGroup = _objectSpread(_objectSpread({}, currentFieldGroup), fieldData);
      });
      acc = _objectSpread(_objectSpread({}, acc), {
        [fieldName]: currentFieldGroup
      });
      return acc;
    }
    return acc;
  }, {});
  data.applicantDetails.birthCountryId = context['currentNationalityId'] && context['currentNationalityId'].value;
  data.passportDetails.passportIssueGovId = context['passportIssueCountryId'] && context['passportIssueCountryId'].value;
  data.contactInfo.preferredSmsLanguage = '2';
  data.visitDetails.entryType = 2;
  data.contactInfo.mobileNo = '971500000000';
  const requestOptions = {
    method: 'POST',
    redirect: 'follow',
    body: JSON.stringify(_objectSpread(_objectSpread({}, staticData), data))
  };
  const url = `${apiUrl}/v1/orc/application/${serviceId}`;
  const result = await fetchData(url, requestOptions, {
    apiKey,
    sessionId,
    isTokkenValue: true,
    userTokken
  });
  const {
    status,
    data: resultData = {},
    desc = {}
  } = result;
  if (status === 401) {
    history.push(redirectUrl);
  }
  return _objectSpread(_objectSpread({}, resultData), {}, {
    error: desc
  });
};
export const Translate = async function (_ref3) {
  let {
    apiUrl = '',
    apiKey = '',
    sessionId = '',
    userTokken = null,
    history,
    redirectUrl
  } = _ref3;
  let text = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  const data = {
    TextToTranslate: text,
    IsEnglishToArabic: true
  };
  const url = `${apiUrl}/v1/proxy/translate`;
  const requestOptions = {
    method: 'POST',
    body: JSON.stringify(data),
    redirect: 'follow'
  };
  const result = await fetchData(url, requestOptions, {
    apiKey,
    sessionId,
    isTokkenValue: true,
    userTokken
  });
  const {
    status,
    TranslatedText
  } = result;
  if (status === 401) {
    history.push(redirectUrl);
  }
  if (status === 500) return text;
  return TranslatedText || text;
};
export const GetDetails = async (_ref4, applicationNumber) => {
  let {
    apiUrl = '',
    apiKey = '',
    sessionId = '',
    userTokken = null,
    history,
    redirectUrl
  } = _ref4;
  const url = `${apiUrl}/v1/proxy/details/${applicationNumber}`;
  const requestOptions = {
    method: 'GET',
    redirect: 'follow'
  };
  const result = await fetchData(url, requestOptions, {
    apiKey,
    sessionId,
    isTokkenValue: true,
    userTokken
  });
  const {
    status,
    applicationRequest = {}
  } = result;
  if (status === 401) {
    history.push(redirectUrl);
  }
  const data = reduce(applicationRequest, (acc, fields) => {
    forEach(fields, (value, name) => {
      acc = _objectSpread(_objectSpread({}, acc), {
        [name]: value
      });
    });
    return acc;
  }, {});
  if (data.sponsorEmail) data.ConfirmEmail = data.sponsorEmail;
  if (data.sponsorEmail) data.email = data.sponsorEmail;
  if (data.faithId) data.FaithId = data.faithId;

  // if (data.mobileNo) {
  //   const parsedmobileNo = parsePhoneNumber(data.mobileNo);

  //   if (parsedmobileNo) data.mobileNo = parsedmobileNo.nationalNumber;
  // }

  // if (data.addressOutsideTelNo) {
  //   const parsedmobileNo = parsePhoneNumber(`+${data.addressOutsideTelNo}`);

  //   if (parsedmobileNo) data.addressOutsideTelNo = parsedmobileNo.nationalNumber;
  // }

  return data;
};
export const Notify = async (_ref5, context) => {
  let {
    apiUrl = '',
    apiKey = '',
    sessionId = '',
    userTokken = null,
    username = ''
  } = _ref5;
  const data = {
    email: context['notifyEmail'].value,
    firstNameEN: context['firstNameEN'].value,
    middleNameEN: context['middleNameEN'].value,
    lastNameEN: context['lastNameEN'].value,
    nationality: context['currentNationalityId'].value,
    passportIssueGov: context['passportIssueCountryId'].value,
    birthDate: context['birthDate'].value,
    mobileNo: '',
    username
  };
  const url = `${apiUrl}/v1/orc/notify`;
  const requestOptions = {
    method: 'POST',
    body: JSON.stringify(data),
    redirect: 'follow'
  };
  const result = await fetchData(url, requestOptions, {
    apiKey,
    sessionId,
    isTokkenValue: true,
    userTokken
  });
  const {
    status,
    Success
  } = result;
  if (status !== 200) return false;
  return Success;
};
export const IdndividualProfileInquiry = async (_ref6, context) => {
  let {
    apiUrl = '',
    apiKey = '',
    sessionId = '',
    userTokken = null,
    history,
    redirectUrl
  } = _ref6;
  const yearOfBirth = new Date(context['birthDate'].value.replaceAll('-', '/') || '');
  const data = {
    passportNo: context['passportNo'].value,
    nationalityId: context['currentNationalityId'].value,
    yearOfBirth: yearOfBirth.getFullYear(),
    fileType: context['passportTypeId'].value,
    fileNo: ''
  };
  const url = `${apiUrl}/v1/orc/resource/inquiry/individual/profile`;
  const requestOptions = {
    method: 'POST',
    body: JSON.stringify(data),
    redirect: 'follow'
  };
  const result = await fetchData(url, requestOptions, {
    apiKey,
    sessionId,
    isTokkenValue: true,
    userTokken
  });
  const {
    status = 500,
    profileInquiryConsolidated
  } = result;
  if (status === 401) {
    history.push(redirectUrl);
  }
  if (status !== 200 || !profileInquiryConsolidated) return {
    status
  };
  const {
    contactInfo,
    passportDetails,
    personInfo,
    prsNationality
  } = profileInquiryConsolidated;
  return {
    data: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, contactInfo), passportDetails), personInfo), {}, {
      prsNationality
    }),
    status
  };
};
export const GetAllLookups = async _ref7 => {
  let {
    apiUrl = '',
    apiKey = '',
    sessionId = '',
    userTokken = null,
    history
  } = _ref7;
  const url = `${apiUrl}/v1/orc/lookups`;
  const requestOptions = {
    method: 'GET'
  };
  const result = await fetchData(url, requestOptions, {
    apiKey,
    sessionId,
    userTokken
  });
  const {
    status = 200
  } = result;
  if (status !== 200) return [];
  return result && result[0] && result[0].lookupData || [];
};
export const GetLookupById = async _ref8 => {
  let {
    apiUrl = '',
    apiKey = '',
    sessionId = '',
    userTokken = null,
    lookupid = ''
  } = _ref8;
  const url = `${apiUrl}/v1/proxy/lookup/${lookupid}/items`;
  const requestOptions = {
    method: 'GET'
  };
  const result = await fetchData(url, requestOptions, {
    apiKey,
    sessionId,
    userTokken
  });
  const {
    status = 200
  } = result;
  if (status !== 200 || isEmpty(result)) return [];
  return result || [];
};
export const GetPaymentURL = async (_ref9, applicationNumber) => {
  let {
    apiUrl = '',
    apiKey = '',
    sessionId = '',
    userTokken = null,
    history,
    redirectUrl
  } = _ref9;
  const url = `${apiUrl}/v1/orc/payment/${applicationNumber}/url?isEmbeded=true`;
  const requestOptions = {
    method: 'GET'
  };
  const result = await fetchData(url, requestOptions, {
    apiKey,
    sessionId,
    isTokkenValue: true,
    userTokken,
    isGetRequest: true
  });
  const {
    status,
    NoqodiPaymentURL,
    desc
  } = result;
  if (status === 401) {
    history.push(redirectUrl);
  }
  return {
    paymentUrl: NoqodiPaymentURL,
    error: desc
  };
};
export const GetFees = async function (_ref10, applicationId) {
  let {
    apiUrl = '',
    apiKey = '',
    sessionId = '',
    userTokken = null,
    redirectUrl = '',
    history,
    dashboardUrl
  } = _ref10;
  let validate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  const url = `${apiUrl}/v1/proxy/application/fees`;
  const data = {
    applicationId,
    validate
  };
  const requestOptions = {
    method: 'POST',
    redirect: 'follow',
    body: JSON.stringify(data)
  };
  const result = await fetchData(url, requestOptions, {
    apiKey,
    sessionId,
    isTokkenValue: true,
    userTokken
  });
  const {
    status,
    fees: feesList = [],
    desc: error = {}
  } = result;
  if (status === 401) {
    history.push(redirectUrl);
  }
  return {
    feesList,
    error
  };
};
export const Search = async (_ref11, ApplicationNo) => {
  let {
    apiUrl = '',
    apiKey = '',
    sessionId = '',
    userTokken = null,
    redirectUrl = '',
    history,
    dashboardUrl
  } = _ref11;
  const url = `${apiUrl}/v1/proxy/inquiry/individual/application/search`;
  const data = {
    ApplicationNo,
    pageNumber: 1,
    pageSize: 10,
    statusIds: '',
    includeService: '',
    excludeService: ''
  };
  const requestOptions = {
    method: 'POST',
    redirect: 'follow',
    body: JSON.stringify(data)
  };
  const result = await fetchData(url, requestOptions, {
    apiKey,
    sessionId,
    isTokkenValue: true,
    userTokken
  });
  const {
    status,
    ApplicationList = [],
    desc: error = {}
  } = result;
  const applicationData = ApplicationList[0];
  if (status === 401) {
    history.push(redirectUrl);
  }
  return {
    applicationData,
    error
  };
};
export const ApplicationStatus = async function (_ref12, applicationId) {
  let {
    apiUrl = '',
    apiKey = '',
    sessionId = '',
    userTokken = null,
    redirectUrl = '',
    history
  } = _ref12;
  let validate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  const url = `${apiUrl}//v1/proxy/resource/inquiry/application/${applicationId}/status`;
  const requestOptions = {
    method: 'GET',
    redirect: 'follow'
  };
  const result = await fetchData(url, requestOptions, {
    apiKey,
    sessionId,
    isTokkenValue: true,
    userTokken
  });
  const {
    status,
    fees
  } = result;
  if (status === 401) {
    history.push(redirectUrl);
  }
  return fees || [];
};
export const getDocumentsData = async (_ref13, applicationNumber) => {
  let {
    apiUrl = '',
    apiKey = '',
    sessionId = '',
    userTokken = null
  } = _ref13;
  const url = `${apiUrl}/v1/proxy/application/${applicationNumber}/documents`;
  const requestOptions = {
    method: 'GET'
  };
  const result = await fetchData(url, requestOptions, {
    apiKey,
    sessionId,
    isTokkenValue: true,
    userTokken
  });
  return result;
};
export const UploadDocument = async (_ref14, applicationId, documentsObject, onProgress) => {
  let {
    apiUrl = '',
    apiKey = '',
    userTokken = null,
    sessionId = ''
  } = _ref14;
  const data = {
    Documents: documentsObject,
    applicationId
  };
  const url = `${apiUrl}/v1/orc/application/documents/upload`;
  const xhr = new XMLHttpRequest();
  return await new Promise((resolve, reject) => {
    xhr.upload.addEventListener('progress', event => {
      if (event.lengthComputable) {
        onProgress(Math.round(event.loaded / event.total * 100));
      }
    });
    xhr.addEventListener('readystatechange', () => {
      if (xhr.readyState === XMLHttpRequest.DONE) {
        try {
          resolve(JSON.parse(xhr.responseText));
        } catch (err) {
          reject(err);
        }
      }
    });
    xhr.open('POST', url, true);
    xhr.setRequestHeader('X-Request-Id', sessionId);
    xhr.setRequestHeader('Apikey', apiKey);
    xhr.setRequestHeader('Authorization', userTokken || TOKKEN);
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.setRequestHeader('Accept', 'application/json');
    xhr.setRequestHeader('Host', 'dacqa.detsandbox.com');
    xhr.setRequestHeader('User-Agent', 'Apidog/1.0.0 (https://apidog.com)');
    xhr.send(JSON.stringify(data));
  });
};
export const PaymentValidation = async (_ref15, data) => {
  let {
    apiUrl = '',
    apiKey = '',
    userTokken = null,
    sessionId = ''
  } = _ref15;
  const url = `${apiUrl}/v1/orc/payment/complete`;
  const requestOptions = {
    method: 'POST',
    body: JSON.stringify(data)
  };
  const {
    Success,
    desc: error = {},
    status
  } = await fetchData(url, requestOptions, {
    apiKey,
    sessionId,
    userTokken,
    isTokkenValue: true
  });
  if (status === 200) return {
    Success: true,
    error
  };
  return {
    Success,
    error
  };
};
export const GetInvitationCodes = async (_ref16, data) => {
  let {
    apiUrl = '',
    apiKey = '',
    userTokken = null,
    sessionId = ''
  } = _ref16;
  const url = `${apiUrl}/v1/orc/invitationcodes`;
  const requestOptions = {
    method: 'POST',
    body: JSON.stringify(data)
  };
  const {
    Success,
    desc: error = {}
  } = await fetchData(url, requestOptions, {
    apiKey,
    sessionId,
    userTokken
  });
  return {
    Success,
    error
  };
};
export const uploadConsent = async (_ref17, sendData) => {
  let {
    apiKey = '',
    sessionId = ''
  } = _ref17;
  const url = 'https://app5.securiti.ai/privaci/v1/consentapi/consent_upload';
  const headers = new Headers();
  headers.append('X-Request-Id', sessionId);
  headers.append('Content-Type', 'application/json');
  headers.append('Host', 'app.eu.securiti.ai');
  headers.append('X-API-Key', '8s0xdf9DmCBT6vFLOCbtSwB3GZ5Cxq46k5zgXrB8');
  headers.append('X-API-Secret', 'tjVkG6z3fSbBuKb24P8HM5qc3LzOgYviICqsC772');
  headers.append('X-TIDENT', '0f26a629-0c1e-4d0f-a04b-add9ce0aaeec');
  const data = _objectSpread({}, sendData);
  const requestOptions = {
    headers,
    method: 'POST',
    body: JSON.stringify(data)
  };
  try {
    const response = await fetch(url, requestOptions);
    try {
      const data = await response.json();
      if (isArray(data)) return data;
      return _objectSpread(_objectSpread({}, data), {}, {
        status: response.status
      });
    } catch {
      return {
        status: response.status
      };
    }
  } catch {
    return {};
  }
};